module.exports = __webpack_public_path__ + "img/1568913618.fd7e2804.jpg";